const defaults = {
  overlayClass: 'video-container__overlay',
  hasOverlayClass: 'has-overlay',
  isHiddenClass: 'is-hidden'
};

class videoContainer {

  constructor (element) {
    const { overlayClass } = defaults;
    this.videoWrapper = element;
    this.videoEl = this.videoWrapper.querySelector('video');
    this.videoOverlay = document.createElement('div');
    this.videoOverlay.className = overlayClass;
  }

  insertOverlay () {
    const { hasOverlayClass } = defaults;
    const videoPoster = this.videoEl.getAttribute('poster');
    this.videoWrapper.appendChild(this.videoOverlay);
    this.videoWrapper.classList.add(hasOverlayClass);
    if (videoPoster) {
      this.videoOverlay.style.backgroundImage = `url("${videoPoster}")`;
    }
  }

  addEventListeners () {
    const { hasOverlayClass, isHiddenClass } = defaults;
    this.videoOverlay.addEventListener('click', () => {
      this.videoOverlay.classList.add(isHiddenClass);
      this.videoWrapper.classList.remove(hasOverlayClass);
      this.videoEl.play();
    });
  }

  init () {
    this.insertOverlay();
    this.addEventListeners();
  }

}

export default videoContainer;
